import React from "react";

function splitFirstWord(text) {
  const value = String(text || "");
  const trimmed = value.trimStart();
  const leadingWhitespace = value.slice(0, value.length - trimmed.length);
  const match = trimmed.match(/^(\S+)(\s*)([\s\S]*)$/);

  if (!match) {
    return {
      leadingWhitespace,
      firstWord: trimmed,
      separator: "",
      rest: "",
    };
  }

  return {
    leadingWhitespace,
    firstWord: match[1],
    separator: match[2],
    rest: match[3],
  };
}

export default function LocalizedLeadParagraph({ text, index, locale }) {
  if (index !== 0) return <p>{text}</p>;

  if (locale === "ar") {
    const { leadingWhitespace, firstWord, separator, rest } = splitFirstWord(text);

    return (
      <p className="qtech-service-paragraph qtech-service-paragraph-ar">
        {leadingWhitespace}
        <span className="qtech-first-word">{firstWord}</span>
        {separator}
        {rest}
      </p>
    );
  }

  const value = String(text || "");
  return (
    <p className="qtech-service-paragraph">
      <span className="ltn__first-letter">{value.charAt(0)}</span>
      {value.slice(1)}
    </p>
  );
}
